import { Box } from '@chakra-ui/react';

import { PaperWithShadow } from 'uiToolkitV1/Paper';

import { CFTabPanelsIntent } from './components/CFTabPanelsIntent';

const FeedbackIntentLandingPage = () => (
  <div>
    <Box>
      <PaperWithShadow borderRadius="8px">
        <CFTabPanelsIntent />
      </PaperWithShadow>
    </Box>
  </div>
);

export { FeedbackIntentLandingPage };
